import React from "react";
import HLine from "../../components/components/hline";
import { List, ListItem } from "../../components/components/list";
import {
  Heading,
  Description,
  FirstLetter,
  Row,
} from "../../components/components/text";
import {
  BlueTitle,
  RedTitle,
  Title,
  Date,
  TitleContent,
} from "../../components/components/titles";

export default function HomePage() {
  return (
    <>
      <HLine />
      <Heading>News</Heading>
      <HLine />
      <Row>
        <Title>
          <Date>6. December 2004</Date> -{" "}
          <TitleContent>
            New Prices and Durations for Premium Accounts
          </TitleContent>
        </Title>
        <Description>
          <FirstLetter>A</FirstLetter>s a part of the reform of the payment
          system we have decided to change the existing Premium Account offers.
          Starting from <strong>January 3, 2005</strong> Tibia Premium Accounts
          will come with new prices and durations. The current prices and
          durations of Premium Accounts will apply to all orders made before
          this date. Here is the list of the new offers:
          <List>
            <ListItem>
              <strong>EUR 19.95:</strong> Tibia Premium Account for{" "}
              <strong>3 months</strong> (90 days)
            </ListItem>
            <ListItem>
              <strong>EUR 34.95:</strong> Tibia Premium Account for{" "}
              <strong>6 months</strong> (180 days)
            </ListItem>
            <ListItem>
              <strong>EUR 59.95:</strong> Tibia Premium Account for{" "}
              <strong>12 months</strong> (360 days)
            </ListItem>
          </List>
          Please understand that due to the downswing of the US-Dollar we had to
          adjust the prices and decided to switch to the Euro as the official
          payment currency. Moreover, the new durations are introduced to make
          the Premium Accounts more transparent. Kind regards, Your CipSoft Team
        </Description>
      </Row>
      <Row>
        <BlueTitle>
          <Date>6. December 2004</Date> -{" "}
          <TitleContent>
            New Prices and Durations for Premium Accounts
          </TitleContent>
        </BlueTitle>
        <Description>
          <FirstLetter>A</FirstLetter>s a part of the reform of the payment
          system we have decided to change the existing Premium Account offers.
          Starting from <strong>January 3, 2005</strong> Tibia Premium Accounts
          will come with new prices and durations. The current prices and
          durations of Premium Accounts will apply to all orders made before
          this date. Here is the list of the new offers:
          <List>
            <ListItem>
              <strong>EUR 19.95:</strong> Tibia Premium Account for{" "}
              <strong>3 months</strong> (90 days)
            </ListItem>
            <ListItem>
              <strong>EUR 34.95:</strong> Tibia Premium Account for{" "}
              <strong>6 months</strong> (180 days)
            </ListItem>
            <ListItem>
              <strong>EUR 59.95:</strong> Tibia Premium Account for{" "}
              <strong>12 months</strong> (360 days)
            </ListItem>
          </List>
          Please understand that due to the downswing of the US-Dollar we had to
          adjust the prices and decided to switch to the Euro as the official
          payment currency. Moreover, the new durations are introduced to make
          the Premium Accounts more transparent. Kind regards, Your CipSoft Team
        </Description>
      </Row>
      <Row>
        <RedTitle>
          <Date>6. December 2004</Date> -{" "}
          <TitleContent>
            New Prices and Durations for Premium Accounts
          </TitleContent>
        </RedTitle>
        <Description>
          <FirstLetter>A</FirstLetter>s a part of the reform of the payment
          system we have decided to change the existing Premium Account offers.
          Starting from <strong>January 3, 2005</strong> Tibia Premium Accounts
          will come with new prices and durations. The current prices and
          durations of Premium Accounts will apply to all orders made before
          this date. Here is the list of the new offers:
          <List>
            <ListItem>
              <strong>EUR 19.95:</strong> Tibia Premium Account for{" "}
              <strong>3 months</strong> (90 days)
            </ListItem>
            <ListItem>
              <strong>EUR 34.95:</strong> Tibia Premium Account for{" "}
              <strong>6 months</strong> (180 days)
            </ListItem>
            <ListItem>
              <strong>EUR 59.95:</strong> Tibia Premium Account for{" "}
              <strong>12 months</strong> (360 days)
            </ListItem>
          </List>
          Please understand that due to the downswing of the US-Dollar we had to
          adjust the prices and decided to switch to the Euro as the official
          payment currency. Moreover, the new durations are introduced to make
          the Premium Accounts more transparent. Kind regards, Your CipSoft Team
        </Description>
      </Row>
    </>
  );
}
